import { AuthProvider, useAuth } from "./auth";
import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import ToastClearAll from "./ToastClearAll";
import ErrorBoundary from "./ErrorBoundary";
import Login from "./Login";
import BreakManager from "./BreakManager";
import ExitConfirm from "./ExitConfirm";
import ExitStatus from "./ExitStatus";

function Gate() {
  const { token } = useAuth();
  const [, bump] = useState(0);
  useEffect(() => {
    const f = () => bump((x) => x + 1);
    window.addEventListener("kairos-tz", f);
    return () => window.removeEventListener("kairos-tz", f);
  }, []);
  return token ? <BreakManager /> : <Login />;
}

export default function App() {
  const exitMatch = window.location.pathname.match(/^\/exit-confirm\/([^/]+)/);
  if (exitMatch) {
    return (
      <ErrorBoundary name="exit-confirm">
        <ExitConfirm token={decodeURIComponent(exitMatch[1])} />
        <Toaster richColors closeButton position="top-right" />
      </ErrorBoundary>
    );
  }
  const statusMatch = window.location.pathname.match(/^\/exit-status\/([^/]+)/);
  if (statusMatch) {
    return (
      <ErrorBoundary name="exit-status">
        <ExitStatus token={decodeURIComponent(statusMatch[1])} />
        <Toaster richColors closeButton position="top-right" />
      </ErrorBoundary>
    );
  }
  return (
    <ErrorBoundary name="app">
      <AuthProvider>
        <Gate />
        <Toaster richColors closeButton position="top-right" />
        <ToastClearAll />
      </AuthProvider>
    </ErrorBoundary>
  );
}
